// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3glPM","clinicsSelect":"styles_clinicsSelect__2lnE2"};